import Head from 'next/head';
import { ContentBrowser } from '@/components/content/ContentBrowser';
import { useUrlSync } from '@/lib/hooks/useUrlSync';

export default function ContentListPage() {
  const { values, handlers, isReady } = useUrlSync({
    filters: {
      search: { paramName: 'search', defaultValue: '' },
      type: { paramName: 'type', defaultValue: [], isArray: true },
      tags: { paramName: 'tags', defaultValue: [], isArray: true },
    },
  });

  return (
    <>
      <Head>
        <title>Content | Sizzle</title>
        <meta name="description" content="Browse published content on Sizzle." />
      </Head>
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">Content</h1>
          {isReady && (
            <ContentBrowser
              query={{
                status: 'published',
                visibility: 'public',
                type: values.type.length > 0 ? values.type : undefined,
                tags: values.tags.length > 0 ? values.tags : undefined,
              }}
              mobileColumns={1}
              initialSearch={values.search}
              initialFilters={{ type: values.type, tags: values.tags }}
              onSearchChange={handlers.search}
              onFiltersChange={(filters) => {
                handlers.type(filters.type || []);
                handlers.tags(filters.tags || []);
              }}
              searchPlaceholder="Search..."
              showTypeFilter={true}
              cardProps={{ showTypeBadge: true, showTags: false }}
              limit={20}
            />
          )}
        </div>
      </div>
    </>
  );
}
